import { AlertTriangle } from 'lucide-react';
import { Modal } from './Modal';
import { Button } from './Button';

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmLabel?: string;
  variant?: 'danger' | 'warning';
  loading?: boolean;
}

export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = 'Confirm',
  variant = 'danger',
  loading = false,
}: ConfirmDialogProps) {
  return (
    <Modal open={open} onClose={onClose} title="" maxWidth="max-w-md">
      <div className="flex flex-col items-center text-center gap-4 py-2">
        <div className={`rounded-full p-3 ${
          variant === 'danger' ? 'bg-red-500/10' : 'bg-amber-500/10'
        }`}>
          <AlertTriangle className={`h-6 w-6 ${
            variant === 'danger' ? 'text-red-400' : 'text-amber-400'
          }`} />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-surface-100">{title}</h3>
          <p className="mt-1 text-sm text-surface-400">{description}</p>
        </div>
        <div className="flex gap-3 w-full">
          <Button variant="secondary" onClick={onClose} className="flex-1">
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            loading={loading}
            className="flex-1"
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
